import React from 'react';

const COUNTRIES = [
  { flag:'🇸🇦', name:'Saudi Arabia', detail:'GOSI · Zakat · Dispatch fee' },
  { flag:'🇮🇳', name:'India',        detail:'PF · ESI · Actual Tax slabs' },
  { flag:'🇦🇺', name:'Australia',    detail:'Super · Payroll tax · Medicare levy' },
  { flag:'🇺🇸', name:'United States',detail:'FICA · FUTA · SUTA · VMS fee' },
  { flag:'🇳🇱', name:'Netherlands',  detail:'WAO/WW/ZVW · 30% ruling · Tax credits' },
  { flag:'🇯🇵', name:'Japan',        detail:'Kyokai Kenpo · Kosei Nenkin · Resident tax' },
  { flag:'🇳🇴', name:'Norway',       detail:'Trinnskatt · Minstefradrag · Trygdeavgift' },
  { flag:'🇨🇳', name:'China',        detail:'12-city housing fund · SS · IIT slabs' },
];

export default function Countries() {
  return (
    <section className="countries" id="countries">
      <div className="container">
        <div className="section-label">Coverage</div>
        <h2 className="section-title">8 countries. Every statutory cost.</h2>
        <p className="section-sub">
          Each country is implemented from official government sources — not estimated.
          Rates are updated in the admin panel as legislation changes.
        </p>
        <div className="countries-grid">
          {COUNTRIES.map(c => (
            <div className="country-card" key={c.name}>
              <span className="country-flag">{c.flag}</span>
              <span className="country-name">{c.name}</span>
              <span className="country-detail">{c.detail}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
